/**
 * Group First, then Alphanumeric order
 */

/**
 * Shop Group
 */
export const GET_ALL_SHOPS_SUCCESS = 'GET_ALL_SHOPS_SUCCESS';
export const CREATE_SHOP_SUCCESS = 'CREATE_SHOP_SUCCESS';
// export const UPDATE_SHOP_SUCCESS = 'UPDATE_SHOP_SUCCESS';

export const CREATE_CATEGORY_SUCCESS = 'CREATE_CATEGORY_SUCCESS';
export const CREATE_SUB_CATEGORY_SUCCESS = 'CREATE_SUB_CATEGORY_SUCCESS';

/**
 * contact
 */

export const LOAD_ALL_CONTACTS_SUCCESS = 'LOAD_ALL_CONTACTS_SUCCESS';

/**
 * CONTACT TYPES
 */
// export const LOAD_CONTACT_TYPE_SUCCESS = 'LOAD_CONTACT_TYPE_SUCCESS';

/**
 * ChartOfAccounts
 */
export const LOAD_CHART_OF_ACCOUNT_SUCCESS = 'LOAD_CHART_OF_ACCOUNT_SUCCESS';


/**
 * Feature Classes
 */
export const LOAD_FEATURE_CLASSES_SUCCESS = 'LOAD_FEATURE_CLASSES_SUCCESS';
export const SAVE_NEW_FEATURE_CLASS_SUCCESS = 'SAVE_NEW_FEATURE_CLASS_SUCCESS';

export const SAVE_NEW_FEATURE_SUCCESS = 'SAVE_NEW_FEATURE_SUCCESS';


/**
 *  Product Features
 */
export const LOAD_PRODUCT_FEATURES_SUCCESS = 'LOAD_PRODUCT_FEATURES_SUCCESS';
export const ADD_PRODUCT_FEATURE = 'ADD_PRODUCT_FEATURE';
export const REMOVE_PRODUCT_FEATURE = 'REMOVE_PRODUCT_FEATURE';


/**
 *  Product Locations
 */
export const LOAD_PRODUCT_LOCATIONS_SUCCESS = 'LOAD_PRODUCT_LOCATIONS_SUCCESS';
// export const ADD_PRODUCT_LOCATION_CATEGORY = 'ADD_PRODUCT_LOCATION_CATEGORY';
// export const ADD_PRODUCT_LOCATION_SUB_CATEGORY = 'ADD_PRODUCT_LOCATION_SUB_CATEGORY';


/**
 * Session
 */

export const LOGIN_USER = 'LOGIN_USER';
export const REMOVE_USER = 'REMOVE_USER';



/** WEBPACK FOOTER **
 ** ./src/constants/actionTypes.js
 **/